<div class="mb-8">
  <p class="c-paragraph-base mb-lg">
    Descarga el CV generado con IA en su versión completa o reducida, o bien descarga directamente el CV original
    enviado por el usuario:
  </p>
</div>

<div class="flex flex-col items-center gap-4">
  <desy-button-loader
    classes="w-58"
    [text]="'Descargar CV reducido'"
    [state]="loadingReduced ? 'is-loading' : ''"
    [classes]="loadingReduced ? 'c-button-loader--is-loading' : ''"
    [disabled]="loadingReduced"
    (clickEvent)="downloadCV(false)"></desy-button-loader>

  <desy-button-loader
    classes="w-58"
    [text]="'Descargar CV completo'"
    [state]="loadingStandard ? 'is-loading' : ''"
    [classes]="loadingStandard ? 'c-button-loader--is-loading' : ''"
    [disabled]="loadingStandard"
    (clickEvent)="downloadCV(true)"></desy-button-loader>

  <desy-button-loader
    classes="w-58"
    [text]="'Descargar CV original'"
    [state]="loadingOriginal ? 'is-loading' : ''"
    [classes]="loadingOriginal ? 'c-button-loader--is-loading' : ''"
    [disabled]="loadingOriginal"
    (clickEvent)="downloadCVOriginal()"></desy-button-loader>
</div>

